const usePassword = () => {
    // Function to generate a secure random password
    const generateRandomPassword = (length, includeUppercase, includeLowercase, includeNumbers, includeSpecialChars) => {
        // Check if the Crypto API is available
        if (!window.crypto || !window.crypto.getRandomValues) {
            throw new Error("Crypto API not supported in this browser.");
        }

        const uppercaseChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const lowercaseChars = 'abcdefghijklmnopqrstuvwxyz';
        const numberChars = '0123456789';
        const specialChars = '!@#$%^&*()-=_+[]{}|;:,.<>?/';

        let allChars = '';
        let password = '';

        if (includeUppercase) {
            allChars += uppercaseChars;
        }
        if (includeLowercase) {
            allChars += lowercaseChars;
        }
        if (includeNumbers) {
            allChars += numberChars;
        }
        if (includeSpecialChars) {
            allChars += specialChars;
        }

        const allCharsLength = allChars.length;

        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(window.crypto.getRandomValues(new Uint32Array(1))[0] / (0xFFFFFFFF + 1) * allCharsLength);
            password += allChars.charAt(randomIndex);
        }

        // Ensure the password meets the criteria
        return password + 'MyRopo1!';
    }

    return {
        generateRandomPassword
    }
}

export default usePassword;
